export default __webpack_public_path__ + "src/images/packages/lachataigne-farm/75c3bf2a84de2874582c5e15e576a2e6-2.jpg";